import { createSlice } from "@reduxjs/toolkit";
import { createOrderThunk, deleteOrderThunk, extendOrderThunk, fetchOrderById } from "./orders.fetch";

const initialState = {
  orderInfo: null,
  currentOrder: null,
  isLoading: false,
  isError: null,
};

const ordersReducers = createSlice({
  name: "ordersReduser",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createOrderThunk.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.orderInfo = payload;
      })
      .addCase(createOrderThunk.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(createOrderThunk.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isError = payload;
      })
      .addCase(fetchOrderById.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.currentOrder = payload;
      })
      .addCase(fetchOrderById.pending, (state) => {
        state.isLoading = true;
        state.isError = null;
      })
      .addCase(fetchOrderById.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isError = payload;
      })
      .addCase(extendOrderThunk.fulfilled, (state, { payload }) => {
        if (state.currentOrder) {
          state.currentOrder.expiresAt = payload.expiresAt;
        }
        state.isLoading = false;
      })
      .addCase(extendOrderThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(extendOrderThunk.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isError = payload.error;
       
      })
      .addCase(deleteOrderThunk.fulfilled, (state, { payload }) => {
        if (state.currentOrder && state.currentOrder._id === payload) {
          state.currentOrder = null;
        }
        state.isLoading = false;
      })
      .addCase(deleteOrderThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteOrderThunk.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isError = payload;
      });
  },
});

export const orderReduser = ordersReducers.reducer;
